import { render } from "./BackSidedNav.vue?vue&type=template&id=29011842&scoped=true"
import script from "./BackSidedNav.vue?vue&type=script&lang=js"
export * from "./BackSidedNav.vue?vue&type=script&lang=js"

import "./BackSidedNav.vue?vue&type=style&index=0&id=29011842&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29011842"]])

export default __exports__